<script setup lang="ts">
  const props = defineProps({
    text: { type: String, required: true },
    isSubmitting: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  })
</script>

<template>
  <button class="wad4-submit-button" :class="{'wad4-button--disabled': isDisabled}" type="submit">
    <span v-if="isSubmitting" class="wad4-submit-button__spinner">
      <span class="wad4-submit-button__spinner-circle"></span>
    </span>
    <template v-else>
      <span class="wad4-button__text">{{text}}</span>
      <slot name="postfix"/>
    </template>
  </button>
</template>

<style lang="scss">
.wad4-submit-button {
  &__spinner {
    display: flex;
    justify-content: center;
    align-items: center;

    &-circle {
      width: 30px;
      height: 30px;
      border: 4px solid rgba(255, 255, 255, 0.8);
      border-top: 4px solid $wad4-c-background-bg-brand-solid;
      border-radius: 50%;
      animation: wad4-submit-button__spin-keys 1s linear infinite;
    }
  }
}

@keyframes wad4-submit-button__spin-keys {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
